<div class="auto-login-container">
  <div class="loading-wrapper">
    <div class="spinner-container">
      <div class="custom-spinner"></div>
    </div>
    <h3 class="loading-text">جارٍ معالجة تسجيل الدخول...</h3>
    <p class="loading-subtext">يرجى الانتظار بينما نقوم بالمصادقة على هويتك</p>
  </div>
</div>